import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spin, Space, Skeleton, Button, Radio, Flex, Dropdown, Empty, List, notification, Pagination } from 'antd';
import { LoadingOutlined, RightOutlined, LeftOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { useBrowser } from '../../contexts/BrowserContext';
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_PRODUCT_MODAL_DATA_LIST, FETCH_DISLIKE, FETCH_LIKE, FETCH_PRODUCT_LIST, FETCH_PRODUCT_MODAL_DATA_LIST } from "../../redux/actions";
import { setSelectedId } from "../../redux/slices/selectItemDrawerMenu";
import { setSelectedProductId } from "../../redux/slices/selectProductId";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTER } from "../../router/constants";
import CollectionList from "./CollectionList";
import CategoryFilesList from "./CategoryFilesList";
import ProductModal from './ProductModal';
import { getSingleCollection } from '../../redux/SingleCollectionBanner/action';
import { setLikeFormId } from '../../redux/slices/likeFormIdSlice';
import { setCurrentPage } from '../../redux/slices/currentPageSlice';
import { useUser } from '../../contexts/UserContext';
import DownloadCards from '../download/DownloadCards';
const ProductList = ({ sectionTitle, view, data, collectionData, showMoreStatus }) => {

    const { userConfigs } = useUser();

    const loading = useSelector((state) => state.loading);
    const isAuthenticated = useSelector((state) => state.initialize.isAuthenticated);

    const isCollection = data?.is_collection ?? false;

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [like, setLike] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null)
    const { browser } = useBrowser();
    const [renderOptions, setRenderOptions] = useState({ psb: "planar", uvw: 50, hue_shift: 0, saturation: 0, brightness: 0, contras: 0 });
    const [likedItems, setLikedItems] = useState({});
    const [modalLoading, setModalLoading] = useState(false);

    const [currentPages, setCurrentPages] = useState(data?.meta?.current_page);
    const [product, setProduct] = useState(null);

    const { productModalData } = useSelector((state) => state?.productModalData)
    const { t } = useTranslation();

    const navigate = useNavigate()

    const handleSelectedProductId = (id, selectId) => {

        dispatch({ type: CLEAR_PRODUCT_MODAL_DATA_LIST })

        setModalLoading(true)
        dispatch(setSelectedProductId(id));
        let selectedIndex;
        let files = data?.id === selectId && (data?.files ? data?.files : data?.data ? data?.data : data)
        selectedIndex = files?.findIndex(item => item.id === id)
        setSelectedIndex(selectedIndex)
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });


        if (isCollection || collectionData.isCollection) {
            const collectionRoute = ROUTER.SHOW_SINGLE_COLLECTION;
            navigate(`${collectionRoute}`)
            dispatch(getSingleCollection(id))
        }
        setTimeout(() => {
            setModalLoading(false)
        }, 1000)
    };

    useEffect(() => {
        setProduct(productModalData)
    }, [handleSelectedProductId])
    
    const toggleLike = (id, isLiked) => {
        dispatch(setLikeFormId(id));
        setLikedItems((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
        if (!isAuthenticated) {
            notification.error({
                message: "To register likes for forms, please Login first.",
                description: "You are not logged in yet. Your likes will not be registered in the system.",
                placement: "topRight",
            });
            setTimeout(() => {
                setLikedItems({})
            }, 5000)
        } else {
            dispatch({ type: isLiked ? FETCH_DISLIKE : FETCH_LIKE });
        }
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
    };


    const handlePageChange = (page) => {
        setCurrentPages(page);
        dispatch(setCurrentPage(page));
    };



    const handleSelectedCategoryId = (id) => {
        dispatch(setSelectedId(id));
    }




    const location = useLocation();
    let currentPage = location.pathname;




    const handleInfiniteScroll = () => {
        console.log("fetch more");
        //fetchMoreProducts();
    };


    return loading ? (

        <>
            {sectionTitle !== "" && typeof sectionTitle !== "undefined" ? <h2 className='section-title'>{sectionTitle}</h2> : null}
            {
                view === "list" ?
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 24,
                                }}
                                spin
                            />
                        }
                    />
                    :
                    <Row gutter={[10, 10]} >
                        {
                            Array(16).fill(0).map((_, index) => (
                                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                    <Card
                                        key={index}
                                        hoverable
                                        cover={
                                            <Skeleton.Image
                                                active
                                                className="card-image"
                                                style={{ objectFit: 'cover' }}
                                            />
                                        }
                                        className="product-card loading"
                                    >
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>

            }
        </>
    ) : (

        <InfiniteScroll
            dataLength={12}
            next={handleInfiniteScroll}
            hasMore={false}
            scrollableTarget="content-scroll-target"
            loader={<Spin
                className='infinite-scroll-loading'
                indicator={
                    <LoadingOutlined
                        className='loading-spin'
                        spin
                    />
                }
            />}

        >

            {


                <Row gutter={[10, 10]} className='scroll-row'>
                    {
                        loading ?
                            (
                                Array(15).fill((index) => (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                                        <Skeleton active />
                                    </Col>
                                ))
                            ) :
                            (
                                data ?
                                    <div style={{ width: '100%' }}>
                                        <Flex justify='space-between' align={'center'} style={{ width: '100%' }}>
                                            {
                                                view !== "list" ?
                                                    <h2 className='section-title'
                                                        style={{ marginBottom: '20px', marginLeft: '5px' }}>{data.name ? data.name : collectionData?.name}</h2>
                                                    : <></>
                                            }


                                            {
                                                !collectionData.pagination && currentPage !== '/download' &&
                                                <Link to={data.is_collection ? ROUTER.SHOW_MORE_COLLECTION : ROUTER.SHOW_MORE_PRODUCT}>
                                                    <Button className={userConfigs.dark ? 'show-more show-more-dark' : 'show-more'} type="text"
                                                        onClick={() => { handleSelectedCategoryId(data.id) }}
                                                        icon={<span className="more-dark-icon" />}>
                                                        {t('product.show_more')}
                                                    </Button>
                                                </Link>
                                            }

                                        </Flex>
                                        {
                                            currentPage !== '/download' ?
                                                <div>
                                                    {isCollection || collectionData.isCollection ? (
                                                        <CollectionList
                                                            collections={data.collections ? data.collections : data.data}
                                                            handleSelectedProductId={handleSelectedProductId}
                                                            setOpen={setOpen}
                                                            like={like}
                                                            setLike={setLike}
                                                            categoryId={data.id}
                                                        />
                                                    ) : (
                                                        <CategoryFilesList
                                                            files={data.files ? data.files : data.data ? data.data : data}
                                                            handleSelectedProductId={handleSelectedProductId}
                                                            // likeAndDislike={likeAndDislike}
                                                            setOpen={setOpen}
                                                            like={like}
                                                            setLike={setLike}
                                                            categoryId={data.id}
                                                            likedItems={likedItems}
                                                            toggleLike={toggleLike}
                                                        />
                                                    )}
                                                </div>
                                                :
                                                <div>
                                                    <DownloadCards
                                                        allFiles={data}
                                                        handleSelectedProductId={handleSelectedProductId}
                                                        // likeAndDislike={likeAndDislike}
                                                        setOpen={setOpen}
                                                        like={like}
                                                        setLike={setLike}
                                                        categoryId={data.id}
                                                        likedItems={likedItems}
                                                        toggleLike={toggleLike}
                                                    />
                                                </div>
                                        }
                                    </div>
                                    :
                                    <Empty className='products-empty' />
                            )

                    }
                </Row>
            }
            {

                !isCollection && product != null &&
                <ProductModal product={product} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} likedItems={likedItems}
                    toggleLike={toggleLike} data={data} open={open} setOpen={setOpen} />

            }
            {
                (collectionData.pagination || showMoreStatus === 303) &&
                <Pagination
                    current={data?.meta?.current_page}
                    pageSize={15}
                    total={data?.meta?.total}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                    style={{ marginTop: '50px', marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }}
                />
            }

        </InfiniteScroll >

    );
};

export default ProductList;
